import { ethers } from 'ethers';
import { DposInterface } from '../typechain-types/dpos_contract_interface.sol/DposInterface';
import { DposInterface__factory } from '../typechain-types/factories/dpos_contract_interface.sol/DposInterface__factory';
import { DPOS_CONTRACT_ADDRESS } from '../config/networkConfig';

class ValidatorServiceClass {
  private contract: DposInterface | null = null;
  
  constructor(provider?: ethers.Provider) {
    if (provider) {
      this.initContract(provider);
    }
  }

  public initContract(provider: ethers.Provider) {
    this.contract = DposInterface__factory.connect(DPOS_CONTRACT_ADDRESS, provider);
  }

  public async getValidatorInfo(validatorAddress: string) {
    if (!this.contract) {
      throw new Error('Contract not initialized. Call initContract first.');
    }

    try {
      const validatorInfo = await this.contract.getValidator(validatorAddress);
      
      return {
        totalStake: validatorInfo.total_stake,
        commissionReward: validatorInfo.commission_reward,
        commission: validatorInfo.commission,
        description: validatorInfo.description,
        endpoint: validatorInfo.endpoint,
        owner: validatorInfo.owner
      };
    } catch (error) {
      console.error('Error fetching validator info:', error);
      throw error;
    }
  }

  public async getTotalEligibleVotesCount() {
    if (!this.contract) {
      throw new Error('Contract not initialized. Call initContract first.');
    }

    try {
      return await this.contract.getTotalEligibleVotesCount();
    } catch (error) {
      console.error('Error fetching total eligible votes:', error);
      throw error;
    }
  }

  // Format bigint values from wei to TARA (ether)
  public formatBalance(weiBalance: bigint): string {
    return ethers.formatEther(weiBalance);
  }
}

// Create a singleton instance
const ValidatorService = new ValidatorServiceClass();

// Add the formatBalance as a static function directly on the service object
ValidatorService.formatBalance = function(weiBalance: bigint): string {
  return ethers.formatEther(weiBalance);
};

export default ValidatorService;